import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventosCompartidosService {
  private readonly enPaginaClientesBackOffice = new BehaviorSubject(false);
  constructor(private readonly router: Router) {
    if(!location.href.includes('clientes-backoffice')) return;
    this.enPaginaClientesBackOffice.next(true);
  }
  $enPaginaClientesBackOffice() {
    return this.enPaginaClientesBackOffice.asObservable();
  }
  inicializar() {
    this.enPaginaClientesBackOffice.next(false);
  }
  setEnPaginaClientesBackOffice(status: boolean) {
    this.enPaginaClientesBackOffice.next(status);
  }
}
